import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../firebase";

export const fetchResumeUploadedStatus = async (userId) => {
  if (!userId) return false;
  try {
    // Reference to the document at /users/{userId}/settings/resumeStatus
    const resumeStatusRef = doc(firestore, "users", userId, "settings", "resumeStatus");
    const docSnap = await getDoc(resumeStatusRef);

    // If document exists, return the resumeUploaded flag; otherwise return false
    if (docSnap.exists()) {
      return docSnap.data().resumeUploaded;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error fetching resume uploaded status:", error);
    return false;
  }
};
